@for (button of buttons; track button) {
<app-navbar-button

	[src]="button.src"
	(click)="nav(button)"
	[url]="button.url"
	[label]="button.label">
</app-navbar-button>
}
